import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

function CategorisedFilter() {
  const [searchParams, setSearchParams] = useSearchParams();

  const categorised = searchParams.get('categorised');

  return (
    <div className="w-max">
      <Stack spacing={2}>
        <Typography variant="body2">Categorised</Typography>
        <div className="flex flex-col w-max">
          <RadioGroup
            aria-labelledby="categorised-label"
            defaultValue="all"
            value={categorised || 'all'}
            name="categorised-radio-buttons-group"
            onChange={(event) => {
              setSearchParams((params) => {
                params.set('categorised', event.target.value);
                if (event.target.value === 'all') params.delete('categorised');
                return params;
              });
            }}
          >
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </div>
      </Stack>
    </div>
  );
}

export default CategorisedFilter;
